import styled from "styled-components";

export const ModalContainer = styled.div`
  align-items: center;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 10;

  .children-container {
    position: relative;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  right: 0;
  top: 0;

  button {
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 0px 10px 0px 0px;
    border: none;
    font-weight: 700;
    padding: 1rem 1.3rem;
  }
  button:hover {
    background-color: ${(props) => props.theme.colors.gray72};
  }
`;
